import axios from './axios';

const getNotificationRules = ({ machineId }) =>
  axios({
    method: 'get',
    url: '/v1/notify-rules',
    params: {
      machine_id: machineId
    }
  });

const getNotificationRulesV2 = ({ machineId, metricType }) =>
  axios({
    method: 'get',
    url: `/v2/machines/${machineId}/notification-rules`,
    params: {
      metric_type: metricType
    }
  });

const createNotificationRule = (machineId, payload) =>
  axios({
    method: 'post',
    url: `/v2/machines/${machineId}/notification-rules`,
    data: payload
  });

const updateNotificationRule = (machineId, payload) =>
  axios({
    method: 'put',
    url: `/v2/machines/${machineId}/notification-rules`,
    data: payload
  });

const deleteNotificationRule = (machineId, notificationRuleId) =>
  axios({
    method: 'delete',
    url: `/v2/machines/${machineId}/notification-rules/${notificationRuleId}`
  });

export {
  getNotificationRules,
  getNotificationRulesV2,
  createNotificationRule,
  updateNotificationRule,
  deleteNotificationRule
};
